<template>
  <div v-if="active" class="loader-wrapper">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script setup>


const props = defineProps({
  active: Boolean,
});
</script>

<style scoped>
.loader-wrapper {
  position: relative;
  width: 70px;
  height: 70px;
  margin: auto;
}

.loader-wrapper > div {
  position: absolute;
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-width: 8px;
  border-style: solid;
  border-color: #003cff transparent transparent transparent;
}

.loader-wrapper > div:nth-child(1) {
  animation-delay: -0.45s;
}

.loader-wrapper > div:nth-child(2) {
  animation-delay: -0.3s;
}

.loader-wrapper > div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
